export default "__VITE_ASSET__C4ixQXG5__"